<div class="tw-flex tw-flex-row tw-items-start tw-gap-4 tw-pt-4"
     [class.tw-flex-row-reverse]="showHairFirst">
  <div id="face-section"
       class="tw-w-1/2 tw-relative tw-flex-1 tw-bg-gray-80 tw-pb-8 tw-pt-20 tw-rounded-2.5 tw-shadow-[0px_2px_4px_0px_rgba(0,0,0,0.1)]"
       [class.tw-px-3]="isDravidianScriptUser"
       [class.tw-px-5]="!isDravidianScriptUser"
       (click)="onSelectConcern(appConfig.Shared.Regimen.Class.FACE)">
    <img class="tw-absolute tw-block tw-h-[90px]"
         style="top: -28px;"
         [src]="faceIconUrl"
         alt="face"/>
    <div class="tw-flex tw-flex-col tw-gap-1 tw-mb-6">
      <div class="tw-font-lexend tw-text-500 tw-text-gray-800"
           [style.font-size.px]="concernTextFontSize"
           i18n="@@forSkinBold"> For <b>Skin</b> Problems </div>
    </div>
    <div
      class="tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-2 tw-bg-teal-600 tw-rounded-2 tw-py-1.5 tw-px-2 tw-text-white">
      <p class="tw-text-300 tw-font-bold tw-font-lexend"
         i18n="@@clickHere">Click Here</p>
    </div>
  </div>
  <div id="hair-section"
       class="tw-w-1/2 tw-relative tw-flex-1 tw-bg-gray-80 tw-pb-8 tw-pt-20 tw-rounded-2.5 tw-shadow-[0px_2px_4px_0px_rgba(0,0,0,0.1)]"
       [class.tw-px-3]="isDravidianScriptUser"
       [class.tw-px-5]="!isDravidianScriptUser"
       (click)="onSelectConcern(appConfig.Shared.Regimen.Class.HAIR)">
    <img class="tw-absolute tw-block tw-h-[90px]"
         style="top: -28px;"
         [src]="hairIconUrl"
         alt="hair icon"/>
    <div class="tw-flex tw-flex-col tw-gap-1 tw-mb-6">

      <div class="tw-font-lexend tw-text-500 tw-text-gray-800"
           [style.font-size.px]="concernTextFontSize"
           i18n="@@forHairBold"> For <b>Hair</b> Problems </div>
    </div>
    <div
      class="tw-flex tw-flex-row tw-items-center tw-justify-center tw-gap-2 tw-bg-teal-600 tw-rounded-2 tw-py-1.5  tw-px-2 tw-text-white">
      <p class="tw-text-300 tw-font-bold tw-font-lexend"
         i18n="@@clickHere">Click Here</p>
    </div>
  </div>
</div>
